import React from "react"
import {Box, styled, Typography} from "@mui/material"

const DotBox = styled(Box, {shouldForwardProp: (prop) => prop !== "isThisYear"})(({theme, isThisYear}) => theme.TIMELINECOMPONENT.ICON(theme, isThisYear))

const TimelineDot = ({year}) => {
    const isThisYear = new Date().getFullYear() === year
    return (
        <Box
            display="flex"
            flexDirection="column"
            width="fit-content"
            alignItems="center"
            px={2}
            mt={isThisYear ? "-8px" : 0}
        >
            <Box sx={{
                backgroundColor: "#fff",
                borderRadius: "50%",
                width: isThisYear ? "24px" : "16px",
                height: isThisYear ? "24px" : "16px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}>
                <DotBox isThisYear={isThisYear}/>
            </Box>
            <Typography variant="caption" sx={{mt: 1}}>
                {year}
            </Typography>
            {isThisYear && <Box color="#fff" backgroundColor="#072ECA" borderRadius="16px" p="3px 12px">
                Heute
            </Box>}
        </Box>
    )
}

export default TimelineDot
